import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import BottomNav from './BottomNav';
import { getAuthUser } from '../repositories/LocalDatabase';
import NotificationHUD from './NotificationHUD';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [isLoggedIn, setIsLoggedIn] = useState(() => getAuthUser().isLoggedIn);

  useEffect(() => {
    setIsLoggedIn(getAuthUser().isLoggedIn);
    const handleAuthChange = () => setIsLoggedIn(getAuthUser().isLoggedIn);
    window.addEventListener('hf-auth-change', handleAuthChange);

    // Initialize animation setting on body
    const enabled = localStorage.getItem('animationsEnabled') !== 'false';
    document.body.classList.toggle('no-animations', !enabled);

    const handleRipple = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('button, .ripple-card') as HTMLElement | null;
      if (!target) return;

      // Check if animations are enabled
      const animationsEnabled = localStorage.getItem('animationsEnabled') !== 'false';
      if (!animationsEnabled) return;

      const rect = target.getBoundingClientRect();
      const ripple = document.createElement('span');

      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;

      ripple.style.width = `${size}px`;
      ripple.style.height = `${size}px`;
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      ripple.className = 'ripple-effect';

      const originalPosition = window.getComputedStyle(target).position;
      if (originalPosition === 'static') {
        target.style.position = 'relative';
      }
      target.style.overflow = 'hidden';

      target.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
        ripple.remove();
      });
    };

    document.addEventListener('mousedown', handleRipple);
    return () => {
      document.removeEventListener('mousedown', handleRipple);
      window.removeEventListener('hf-auth-change', handleAuthChange);
    };
  }, []);

  const location = useLocation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
      }}
    >
      {!isLoggedIn && <Header />}
      <main
        key={location.pathname}
        style={{
          flex: 1,
          overflowY: 'auto',
          paddingBottom: '80px',
          animation: 'pageFadeIn 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
        }}
      >
        {children}
      </main>
      <BottomNav />
      <NotificationHUD />
    </div>
  );
}
